import * as React from 'react';
import { NiSpin } from '@component/ant-component/spin';
import '@style/component/loading/api-loading.less';

export const ApiLoading = () => {
  return <NiSpin className="content-loading" size={'large'} />;
};
